import { RecurringTransferFrequency } from '../../../components/TransferFrequency/Types'

export const getFrequencyInterval = (frequency: RecurringTransferFrequency): number => {
  switch (frequency) {
    case 'WEEKLY':
      return 1
    case 'EVERY_OTHER_WEEK':
      return 2
    case 'MONTHLY':
      return 1
    case 'EVERY_3_MONTHS':
      return 3
    case 'EVERY_6_MONTHS':
      return 6
    case 'ANNUALLY':
      return 12
    default:
      throw new Error('Frequency type is no valid.')
  }
}
